import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import taskCostService, { TaskCost } from '../services/taskCostService';
import { useFeatureLimit } from './useUserTier';

export const useTaskCost = (taskType: string) => {
  const { data: taskCost, isLoading: isCostLoading } = useQuery<TaskCost>({
    queryKey: ['taskCost', taskType],
    queryFn: () => taskCostService.getTaskCost(taskType),
    enabled: !!taskType,
  });

  // AI tasks are credit-based only, no tier limits
  return {
    cost: taskCost?.cost_in_credits || 0,
    isActive: taskCost?.is_active || false,
    isCostLoading,
    // AI tasks don't have tier limits - only credit limits
    canUseFeature: true, // Always true for AI tasks (credits will be checked separately)
    usage: 0, // Not applicable for credit-based tasks
    limit: -1, // Unlimited from tier perspective
    remaining: -1, // Not applicable
    isUnlimited: true, // From tier perspective, yes
    isLimitReached: false, // Tier limits don't apply to AI tasks
  };
};

export const useDynamicTaskCost = (useBrandify: boolean) => {
  const normalTask = useTaskCost('Image Generation (Basic)');
  const brandifyTask = useTaskCost('Image Generation with Brandify');

  const currentTask = useBrandify ? brandifyTask : normalTask;

  return {
    ...currentTask,
    taskType: useBrandify ? 'Image Generation with Brandify' : 'Image Generation (Basic)',
    taskName: useBrandify ? 'Brandify Generation' : 'Image Generation',
  };
};